import * as React from "react";
import ConfigContext from "../context/ConfigContext";
import { EngagementConfiguration } from "../types";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface AgentsTypingProps {
  agentsTyping: Array<string>;
}

class AgentsTyping extends React.Component<
  AgentsTypingProps & ConfigExtension,
  {}
> {
  render() {
    // we're just going to take the first agent for now, but multiple agents should
    // be considered and handled here.

    const text = this.props.agentsTyping.length
      ? this.props.config.TypingIndicatorText.replace(
          /@AgentName/,
          this.props.agentsTyping[0] || ""
        )
      : "";

    return <div className="velaro-agents-typing">{text}</div>;
  }
}

// export default AgentsTyping;

export default (props: AgentsTypingProps) => (
  <ConfigContext.Consumer>
    {config => <AgentsTyping config={config} {...props} />}
  </ConfigContext.Consumer>
);
